import styled, { css } from 'styled-components';

export const BorderImage = styled.div`
  ${({ theme }) => css`
    width: 80px;
    height: 80px;
    border: ${theme.border.width.thin} ${theme.border.style.solid} ${theme.color.border.neutral.default};
    border-radius: ${theme.border.radius.pill};
    position: absolute;
    z-index: ${theme.zIndex.absolute};
  `}
`;

export const BackgroundTop = styled.div<{ isVip: boolean }>`
  ${({ isVip, theme }) => css`
    background-color: ${isVip ? theme.color.background.neutral.inverted : theme.color.background.neutral.weak};
    height: 70px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-top-left-radius: ${theme.border.radius.large};
    border-top-right-radius: ${theme.border.radius.large};
  `};
`;

export const NameWrapper = styled.div<{ isVerified: boolean }>`
  ${({ isVerified }) =>
    css`
      display: flex;
      align-items: center;
      width: 100%;
      min-width: ${isVerified ? `calc(100% - 24px)` : '100%'};

      fuel-typography {
        white-space: nowrap;

        p {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      > fuel-typography,
      > fuel-typography > p {
        text-transform: capitalize;
        display: inline-grid;
        max-width: 100%;
      }
    `}

  ${({ isVerified, theme }) =>
    isVerified &&
    css`
      ::after {
        content: '';
        background-color: ${theme.color.background.neutral.default};
        height: 6px;
        width: 6px;
        position: absolute;
        right: 5px;
      }
    `}
`;

export const BaseInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const VehiclesTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
